import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SendChallenge } from './lobby.actions';

export interface PreferenceStateModel {
  lastGame: string;
  lastInitialTimeSecs: number;
  lastIncrementSecs: number;
  lastRated: boolean;
}

const defaults: PreferenceStateModel = {
  lastGame: 'chess',
  lastInitialTimeSecs: 300,
  lastIncrementSecs: 0,
  lastRated: false,
};

@State<PreferenceStateModel>({
  name: 'preferences',
  defaults,
})
export class PreferenceState {
  @Selector()
  static lastGame(state: PreferenceStateModel): string {
    return state.lastGame;
  }

  @Selector()
  static lastInitialTimeSecs(state: PreferenceStateModel): number {
    return state.lastInitialTimeSecs;
  }

  @Selector()
  static lastIncrementSecs(state: PreferenceStateModel): number {
    return state.lastIncrementSecs;
  }

  @Selector()
  static lastRated(state: PreferenceStateModel): boolean {
    return state.lastRated;
  }

  @Action(SendChallenge)
  onSendChallenge(ctx: StateContext<PreferenceStateModel>, action: SendChallenge) {
    ctx.patchState({
      lastGame: action.game,
      lastInitialTimeSecs: action.initialTimeSecs,
      lastIncrementSecs: action.incrementSecs,
      lastRated: action.rated,
    });
  }
}
